// api/login.js
import request from '@/utils/request'

export const generateQrcode = (data) => {
  return request({
    url: '/wechat/generate_qrcode',
    method: 'get',
    data: {
      expire_seconds:'600'
    },
    params: {site_name:data}, 
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'multipart/form-data'
    }
  })
}


export const verifyLogin = (scene_str) => {
  return request({
    url: '/wechat/check_login_status',
    method: 'get',
    params: {
      scene_str
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const onLineAPI = (userId) => {
  
  return request({
    url: `/users/keepalive`,
    method: 'post',
    data:{
      user_id:userId
    }
  })
}
// 检测用户登录状态
export const checkTokenAPI = (token) => {
  return request({
    url: `/users/check_token`,
    method: 'get',
    params:{
      token
    }
  })
}